/******************************************************************************
 * Here are defined actions that might affect multiple reducers, but have no
 * particular state attached to it.
 ******************************************************************************/
import { createAction } from '@reduxjs/toolkit';

export const clearAll = createAction('global/clear');
